import React, { Component } from 'react'
import ReactSwiper from 'react-id-swiper'
import { NavLink } from 'react-router-dom'
import { Flex } from 'antd-mobile'
import injectSheet from 'react-jss'
import lang from 'lodash/lang'
import cx from 'classnames'
import styles from '../assets/styles/components/NavBarSwiper'
import fontawesome from '@fortawesome/fontawesome'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import * as _ from 'lodash'

fontawesome.library.add(faCaretDown, faCaretUp)

class NavBarSwiperComponent extends Component {
  constructor (props) {
    super(props)
    this.catRefs = []
    this.boxShadow = 'inset 0 -4px 0 #D5AD40'
    this.resetBoxShadow = 'none'
    this.textColor = '#D5AD40'
    this.resetTextColor = '#fff'
    this.state = {
      topOfClientRect: undefined,
      isSticky: false,
    }
  }

  getCategoryIdFromUrl = (url) => {
    let isCategory = false
    return url.split('/').find((path) => {
      if (path === 'category') {
        isCategory = true
        return false
      }
      return (isCategory && path !== 'set')
    })
  }

  // Not Ready for React Create Ref in ComponentDidMount
  componentDidMount = () => {
    this.componentDidUpdate()
    this.setState({
      topOfClientRect: this.wrapRef.getBoundingClientRect().top,
    })
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount = () => {
    const {
      isStickyNavbarSwiper,
    } = this.props

    window.removeEventListener('scroll', this.handleScroll)
    isStickyNavbarSwiper(false)
  }

  handleScroll = () => {
    const {
      isStickyNavbarSwiper,
    } = this.props

    if (window.scrollY > this.state.topOfClientRect) {
      if (!this.state.isSticky) {
        isStickyNavbarSwiper(true)
        this.setState({
          isSticky: true,
        }, () => {
          this.wrapRef.style.position = 'fixed'
          this.wrapRef.style.top = 0
          this.wrapRef.style.zIndex = 9
        })
      }
    } else {
      if (this.state.isSticky) {
        isStickyNavbarSwiper(false)
        this.setState({
          isSticky: false,
        }, () => {
          this.wrapRef.style.position = 'static'
          this.wrapRef.style.top = ''
          this.wrapRef.style.zIndex = ''
        })
      }
    }
  }

  componentDidUpdate = () => {
    const {
      categories,
      selectCategory,
      history,
    } = this.props

    const _catId = this.getCategoryIdFromUrl(history.location.pathname)

    if (_catId) {
      if (!categories) {
        return
      }

      let targetIndex, targetCat, parentCat, subTargetIndex

      categories.some((cat, i) => {
        if (cat.id === _catId) {
          targetIndex = i
          targetCat = cat
          return true
        }
        cat.categories.some((subCat, k) => {
          if (subCat.id === _catId) {
            targetIndex = i
            targetCat = subCat
            parentCat = cat
            subTargetIndex = k
            return true
          }
          return false
        })
        return false
      })

      if (targetCat) {
        if (this.swiperWrapper) {
          this.swiperWrapper.swiper.slideTo(targetIndex, 0)
        }
        if (this.subSwiperWrapper) {
          this.subSwiperWrapper.swiper.slideTo(subTargetIndex, 0)
        }
        this.changeCategory(targetCat, parentCat)
      }
    } else {
      selectCategory(null)

      for (var catId in this.catRefs) {
        const ref = this.catRefs[catId]
        if (ref) {
          ref.style.boxShadow = this.resetBoxShadow
          ref.style.color = this.resetTextColor
        }
      }

      if (this.isHome) {
        this.isHome.style.boxShadow = this.boxShadow
        this.isHome.style.color = this.textColor
      }
    }
  }

  changeCategory = (category, parent) => {
    const {
      selectCategory,
    } = this.props

    window.scrollTo(0, 0)

    if (category.categories.length) {
      parent = category
      category = category.categories[0]
    }

    selectCategory(parent || null)

    if (this.isHome) {
      this.isHome.style.boxShadow = this.resetBoxShadow
      this.isHome.style.color = this.resetTextColor
    }
    for (var catId in this.catRefs) {
      const ref = this.catRefs[catId]
      if (ref) {
        ref.style.boxShadow = this.resetBoxShadow
        ref.style.color = this.resetTextColor
      }
    }

    const id = category.id
    if (this.isHome) {
      this.isHome.style.boxShadow = this.resetBoxShadow
      this.isHome.style.color = this.resetTextColor
    }

    const ids = [id]
    if (parent) {
      ids.push(parent.id)
    }
    ids.forEach((id) => {
      const ref = this.catRefs[id]
      if (ref) {
        ref.style.boxShadow = this.boxShadow
        ref.style.color = this.textColor
      }
    })
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    if (this.props.categories === nextProps.categories &&
      this.props.selectedCategory === nextProps.selectedCategory &&
      this.props.location.pathname === nextProps.location.pathname) {
      if (this.props.isNavBarSwiperExpanded !== nextProps.isNavBarSwiperExpanded) {
        // > update component when isNavBarSwiperExpanded changed.
        return true
      }
      return false
    }

    return true
  }

  renderCategoryLinks (categories, parent) {
    if (lang.isEmpty(categories)) {
      return
    }

    const {
      classes,
      history,
      isTakeaway
    } = this.props

    const slideBlockWrapStyle = cx(classes['slide-block-wrap'])
    const slideBlockStyle = cx(classes['slide-block'])

    return (categories.map((cat) => {
      if (cat.takeawayOnly && !isTakeaway) {
        return null
      }
      if (cat.dineinOnly && isTakeaway) {
        return null
      }
      const targetCat = cat.categories.length ? cat.categories[0] : cat
      const path = `/category/${(targetCat.isSet ? 'set/' : '') + targetCat.id}`

      return (
        <div
          key={cat.id}
          className={slideBlockWrapStyle}
        >
          <NavLink
            onClick={() => {
              if (targetCat.isSet) {
                this.props.selectSetCategory(targetCat.id)
              }
            }}
            to={{
              pathname: path,
              state: {
                from: history.location.pathname,
              },
            }}
          >
            <Flex
              justify='center'
              className={slideBlockStyle}
            >
              <div
                className={cat.id}
                ref={ref => {
                  this.catRefs[cat.id] = ref
                }}
              >
                {cat.name}
              </div>
            </Flex>
          </NavLink>

        </div>
      )
    }))
  }

  handleNavSwiperMenuToggle = () => {
    const { updateNavBarSwiperExpand, isNavBarSwiperExpanded } = this.props
    updateNavBarSwiperExpand(!isNavBarSwiperExpanded)
  }

  render () {
    const {
      classes,
      categories,
      selectedCategory,
      selectedTag,
      // match,
      user,
      merchant,
      history,
      intl,
    } = this.props

    // Intl
    const _customizedHotSaleText = _.get(merchant, 'setting.recommendCustomText')
    const _defaultHotSaleText = intl.formatMessage({ id: 'navBarSwiper.hot_sale' })
    const _hotSaleText = _customizedHotSaleText || _defaultHotSaleText
    const _allCategoryText = intl.formatMessage({ id: 'navBarSwiper.all_category' })

    const wrapStyle = cx(classes.wrap, 'navBar-swiper')
    const slideBlockStyle = cx(classes['slide-block'])
    const slideBlockWrapStyle = cx(classes['slide-block-wrap'])
    const reactSwiperStyle = cx(classes['swiper-container'])
    const reactSubSwiperStyle = cx(classes['swiper-container'], classes['sub-swiper'])
    const navCaretStyle = cx(classes['nav-caret'])
    let reactSwiperStackMenuStyle = ''
    let rotateDeg

    if (this.props.isNavBarSwiperExpanded) {
      reactSwiperStackMenuStyle = cx(classes['swiper-container-stack-menu-expanded'])
      rotateDeg = 180
    } else {
      reactSwiperStackMenuStyle = cx(classes['swiper-container-stack-menu-hidden'])
      rotateDeg = 0
    }

    const reactSwiperParams = {
      slidesPerView: 'auto',
      spaceBetween: 1,
      rebuildOnUpdate: true,
    }

    let tagLink = ''
    if (selectedTag) {
      tagLink = (
        <div className={slideBlockWrapStyle}>
          <NavLink
            to={{
              pathname: `/tag/${selectedTag.name}`,
              state: {
                from: history.location.pathname,
              },
            }}
          >
            <Flex
              justify='center'
              className={slideBlockStyle}
            >
              {selectedTag.name}
            </Flex>
          </NavLink>
        </div>
      )
    }

    let subCategorySwiper = ''
    if (selectedCategory && !this.props.isNavBarSwiperExpanded) {
      subCategorySwiper = (
        <ReactSwiper
          {...reactSwiperParams}
          containerClass={reactSubSwiperStyle}
          ref={ref => {
            this.subSwiperWrapper = ref
          }}
        >
          {this.renderCategoryLinks(selectedCategory.categories, selectedCategory)}
        </ReactSwiper>
      )
    }

    let topNavSwiperContent = ''
    if (!this.props.isNavBarSwiperExpanded) {
      topNavSwiperContent = (this.renderCategoryLinks(categories))
    }

    const stackMenuItemStyle = cx(classes['stack-menu-item'])
    let hotSaleItemClassName = ''
    if (!this.props.isNavBarSwiperExpanded) {
      hotSaleItemClassName = slideBlockWrapStyle
    } else {
      hotSaleItemClassName = stackMenuItemStyle
    }

    let _hotSaleItem = ''
    if (!user.permissions || (merchant && user.permissions && user.permissions.indexOf(merchant.id + ':waiter') === -1)) {
      _hotSaleItem = (
        <div className={hotSaleItemClassName}>
          <NavLink
            onClick={() => this.setState({ isNavSwiperMenuShown: false })}
            to={{
              pathname: '/home',
              state: {
                from: history.location.pathname,
              },
            }}
          >
            <Flex
              justify='center'
              className={slideBlockStyle}
            >
              <div
                ref={ref => {
                  this.isHome = ref
                }}
              >
                {_hotSaleText}
              </div>
            </Flex>
          </NavLink>
        </div>
      )
    }

    let _stackMenus = ''
    if (categories) {
      _stackMenus = categories.map((ele) => {
        const targetCat = ele.categories.length ? ele.categories[0] : ele
        const path = `/category/${(targetCat.isSet ? 'set/' : '') + targetCat.id}`
        let to

        if (path !== history.location.pathname) {
          to = { pathname: path, state: { from: history.location.pathname } }
        } else {
          to = { pathname: path + '/#', state: { from: '/home' } }
        }
        return (
          <div
            key={ele.id}
            className={stackMenuItemStyle}
          >
            <NavLink
              onClick={() => this.setState({ isNavSwiperMenuShown: false })}
              to={to}
            >
              <Flex
                justify='center'
                className={slideBlockStyle} style={{ height: 'auto', minHeight: '50px', wordWrap: 'break-all', width: '100%' }}
              >
                <div
                  style={{ paddingBottom: '10px' }} ref={ref => {
                    this.catRefs[ele.id] = ref
                  }}
                >
                  {ele.name}
                </div>
              </Flex>
            </NavLink>
          </div>
        )
      })
    } else {
      _stackMenus = <div />
    }

    const expandButton = (
      <div
        className={cx(classes['nav-swiper-menu'], { [classes['d-none']]: !categories })}
        onClick={this.handleNavSwiperMenuToggle}
      >
        <FontAwesomeIcon
          style={{ transform: 'rotate(' + rotateDeg + 'deg)' }}
          className={navCaretStyle}
          icon='caret-down'
          color='white' />
      </div>
    )
    let topNavMenuSwiper = ''
    if (!this.props.isNavBarSwiperExpanded) {
      topNavMenuSwiper = (
        <div style={{ display: 'flex' }}>
          <ReactSwiper
            {...reactSwiperParams}
            containerClass={reactSwiperStyle}
            ref={ref => {
              this.swiperWrapper = ref
            }}
          >
            {_hotSaleItem}
            {tagLink}
            {topNavSwiperContent}
          </ReactSwiper>
          {expandButton}
        </div>
      )
    } else {
      topNavMenuSwiper = (
        <div className={reactSwiperStackMenuStyle}>
          <div className='title'>
            <div style={{ flex: 1, paddingLeft: 15 }}>
              {_allCategoryText}
            </div>
            {expandButton}
          </div>
          {_hotSaleItem}
          {_stackMenus}
        </div>
      )
    }

    return (
      <div
        className={wrapStyle}
        style={{ width: '100%' }}
        ref={(ctx) => {
          this.wrapRef = ctx
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
          {topNavMenuSwiper}
          {subCategorySwiper}
        </div>
      </div>
    )
  }
};

/**
 * Export
 */
export default injectSheet(styles)(NavBarSwiperComponent)



// WEBPACK FOOTER //
// ./src/components/NavBarSwiper.js